import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newTariffModal from "~/components/tariffs/new-tariff-modal";
import loader from "~/components/modals/loader";
import XLSX from 'xlsx';

export default {
  components: {
    newTariffModal: newTariffModal,
    loader: loader
  },

  data: function data() {
    return {
      search: "",
      loaderText: "Procesando información",
      headers: [{ text: "", value: "", align: 'left', sortable: false, width: 10 }, { text: "Plataforma", value: "platform", sortable: false }, { text: "Canal", value: "channel", sortable: false }, { text: "Subproducto", value: "subproduct", sortable: false }, { text: "Moneda", value: "currency", sortable: false }, { text: "Afiliación", value: "affiliation", sortable: false }, { text: "Comentario", value: "affiliationComment", sortable: false }, { text: "Costo", value: "equipmentCost", sortable: false }, { text: "Comentario", value: "equipmentCostComment", sortable: false }, { text: "Mantenimiento", value: "maintenance", sortable: false }, { text: "Comentario", value: "maintenanceComment", sortable: false }, { text: "Uso de plataforma CE", value: "platformUsageCE", sortable: false }, {
        text: "Comentario",
        value: "platformUsageCEComment",
        sortable: false
      }, { text: "Renovación", value: "renewal", sortable: false }, { text: "Comentario", value: "renewalComment", sortable: false }, { text: "Mantenimiento", value: "maintenanceDollar", sortable: false }],
      tariffs: []
    };
  },

  methods: {
    addNewItem: function addNewItem() {
      this.$refs.newTariffModal.open();
    },
    toDetailTariff: function toDetailTariff(id, data) {
      this.$refs.loaderModal.showLoader();
      this.$store.commit('master-data/setTariff', data);
      this.$router.push("/tariff/" + id);
    },
    updateClass: function updateClass(text) {
      if (text === "No aplica") return {
        "background-color": "#CFD8DC"
      };
      return {
        "background-color": "white"
      };
    },
    reportDownload: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$refs.loaderModal.showLoader();
                try {
                  if (this.tariffs.length) this.download();else this.$swal('Aviso', "No existe registros.", 'warning');
                } catch (error) {
                  console.log(error);
                  this.$swal('Error', 'Error en generar el reporte.', 'error');
                }
                this.$refs.loaderModal.closeLoader();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reportDownload() {
        return _ref.apply(this, arguments);
      }

      return reportDownload;
    }(),
    download: function download() {
      var data = XLSX.utils.json_to_sheet(this.tariffs);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, 'Hoja 01');
      XLSX.writeFile(wb, this.generateFileName());
    },
    generateFileName: function generateFileName() {
      var day = this.$moment().format('YYYY-MM-DDT HH:mm:ss');
      var nameFile = '';

      nameFile = "Reporte_Tarifas_" + day + ".xlsx";
      return nameFile;
    }
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$store.dispatch('master-data/getTariff');

            case 3:
              this.tariffs = _context2.sent;
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);

              this.$controlMessage(_context2.t0);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 6]]);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/tariff/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/tariff/index.vue
// module chunks = 13